// Bild-Komponente mit Authorization-Header.
// Browser senden bei <img src=...> KEINE custom Headers,
// also laden wir das Bild via fetch + erstellen eine Blob-URL.

import { useEffect, useState } from 'react';
import { uploadAuthHeader, uploadImageUrl } from '../api';

export default function AuthImage({ id, ...rest }: { id: string } & React.ImgHTMLAttributes<HTMLImageElement>) {
  const [src, setSrc] = useState<string | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let revoke: string | null = null;
    let cancelled = false;
    (async () => {
      try {
        const headers = uploadAuthHeader() as Record<string, string>;
        const res = await fetch(uploadImageUrl(id), { headers });
        if (!res.ok) throw new Error('http_' + res.status);
        const blob = await res.blob();
        if (cancelled) return;
        const url = URL.createObjectURL(blob);
        revoke = url;
        setSrc(url);
      } catch {
        if (!cancelled) setError(true);
      }
    })();
    return () => {
      cancelled = true;
      if (revoke) URL.revokeObjectURL(revoke);
    };
  }, [id]);

  if (error) return <div style={{ color: '#5F6B68', fontSize: 11 }}>Bild nicht ladbar</div>;
  if (!src) return <div style={{ background: '#F2F8F8', width: 120, height: 120, borderRadius: 6 }} />;
  return <img src={src} {...rest} />;
}
